<template>
  <div class="basic_wrap order-detail-page">
    <div class="red_top_bg order-detail-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('feng.order') }}
      </div>
      <button
        type="button"
        class="top_right wallet-trigger"
        @click="$router.push('/order')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <div
      v-if="data"
      class="detail-content"
    >
      <section class="mission-card">
        <div class="mission-header">
          <img
            class="mission-avatar"
            :src="getOrderImage()"
            alt=""
            @error="onImageError"
          >
          <div class="mission-info">
            <div class="mission-title">
              {{ getOrderTitle() }}
            </div>
            <div class="mission-number">
              [{{ data.ino || '--' }}]
            </div>
          </div>
          <span
            class="status-pill"
            :class="getStatusClass()"
          >
            {{ getStatusText() }}
          </span>
        </div>
      </section>

      <section class="detail-card">
        <div class="detail-row">
          <span class="detail-label">{{ $t('pro.stat') }}</span>
          <span
            class="detail-value status-value"
            :class="getStatusClass()"
          >
            {{ getStatusText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('sky.vote') }}</span>
          <span class="detail-value notranslate">
            {{ getVoteText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">
            <!-- {{ $t('pro.xiadan') }} -->
            {{ $t('orders.certificationResult') }}
          </span>
          <span class="detail-value notranslate">
            {{ getDataText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('pro.otime') }}</span>
          <span class="detail-value">
            {{ data.time || '--' }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('pro2.onumber') }}</span>
          <span class="detail-value">
            {{ getOrderNumber() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('orders.orderPoints') }}</span>
          <span class="detail-value amount-value">
            {{ formatAmount(data.amount) }}
          </span>
        </div>
		
        <div
          v-if="data.zamount>0"
          class="detail-row"
        >
          <span class="detail-label">{{ $t('orders.profit') }}</span>
          <span class="detail-value amount-value">
            {{ formatAmount(data.zamount) }}
          </span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Icon
	} from "vant";
	import Fetch from "../../utils/fetch";
	import defaultAvatar from "../images/31/shop-item.png";

	Vue.use(Icon);
	export default {
		name: "Orderdetail",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				empty: false,
				defaultAvatar: defaultAvatar,
			};
		},
		created() {
			this.$parent.footer("order",true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch("/user/item_order",{
					id: this.$router.history.current.params.id
				}).then((r) => {
					this.data = r.data;
				});
			},
			getOrderImage() {
				return this.data && this.data.item && this.data.item.img ? this.data.item.img : this.defaultAvatar;
			},
			onImageError(event) {
				event.target.src = this.defaultAvatar;
			},
			getOrderTitle() {
				if (this.data && this.data.item && this.data.item.area) {
					return this.data.item.area;
				}
				return this.$t('grapHome.luckyMission');
			},
			getStatusText() {
				if (!this.data || String(this.data.stat) === "0") {
					return this.$t('orders.pending');
				}
				if (Number(this.data.zhong) > 0) {
					return this.$t('orders.profit');
				}
				return this.$t('orders.loss');
			},
			getStatusClass() {
				if (!this.data || String(this.data.stat) === "0") {
					return "is-pending";
				}
				if (Number(this.data.zhong) > 0) {
					return "is-profit";
				}
				return "is-loss";
			},
			getVoteText() {
				return this.joinLabels(this.getVoteLabels());
			},
			getDataText() {
				if (!this.data || String(this.data.stat) === "0") {
					return "--";
				}
				return this.joinLabels(this.getDataLabels());
			},
			getVoteLabels() {
				var labels = [];

				if (String(this.data.da) === "1") {
					labels.push(this.getItemText("sda"));
				}
				if (String(this.data.xiao) === "1") {
					labels.push(this.getItemText("sxiao"));
				}
				if (String(this.data.dan) === "1") {
					labels.push(this.getItemText("sdan"));
				}
				if (String(this.data.shuang) === "1") {
					labels.push(this.getItemText("sshuang"));
				}

				return labels;
			},
			getDataLabels() {
				var labels = [];

				if (String(this.data.ida) === "0") {
					labels.push(this.getItemText("sda"));
				}
				if (String(this.data.ida) === "1") {
					labels.push(this.getItemText("sxiao"));
				}
				if (String(this.data.idan) === "0") {
					labels.push(this.getItemText("sdan"));
				}
				if (String(this.data.idan) === "1") {
					labels.push(this.getItemText("sshuang"));
				}

				return labels;
			},
			getItemText(key) {
				return this.data && this.data.item && this.data.item[key] ? this.data.item[key] : "";
			},
			joinLabels(labels) {
				var result = [];

				for (var i = 0; i < labels.length; i++) {
					if (labels[i] && result.indexOf(labels[i]) === -1) {
						result.push(labels[i]);
					}
				}

				return result.length ? result.join(" / ") : "--";
			},
			getOrderNumber() {
				var id = this.data && this.data.id ? Number(this.data.id) : 0;
				return 16600 + id;
			},
			formatAmount(value) {
				var amount = Number(value || 0);

				if (isNaN(amount)) {
					amount = 0;
				}

				return amount.toFixed(2);
			},
		}
	};
</script>

<style lang="less" scoped>
.order-detail-page {
	min-height: 100vh;
	background: #191818;
	color: #f5f1ec;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.order-detail-top {
	background: #191818;
	color: #f5f1ec;
	border-bottom: 1px solid rgba(112, 90, 68, 0.45);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #f5f1ec;
	}
}

.wallet-trigger {
	top: 9px;
	right: 15px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	color: #f5cfad;
	background: rgba(104, 82, 58, 0.52);
}

.detail-content {
	padding: 14px 16px 20px;
}

.mission-card,
.detail-card {
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(128, 101, 74, 0.88);
	background: #292929;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	box-sizing: border-box;
}

.mission-card {
	margin-bottom: 14px;
}

.mission-header {
	min-height: 94px;
	padding: 16px 23px;
	display: flex;
	align-items: center;
	background: #232323;
	box-sizing: border-box;
}

.mission-avatar {
	width: 58px;
	height: 58px;
	flex: 0 0 58px;
	object-fit: cover;
	border-radius: 8px;
	background: #1b1a1a;
}

.mission-info {
	min-width: 0;
	flex: 1;
	margin-left: 16px;
}

.mission-title {
	overflow: hidden;
	color: #ffc29f;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.mission-number {
	margin-top: 8px;
	overflow: hidden;
	color: #aeb3bb;
	font-size: 13px;
	line-height: 18px;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.status-pill {
	flex: 0 0 auto;
	margin-left: 12px;
	padding: 5px 13px;
	border-radius: 14px;
	font-size: 14px;
	font-weight: 700;
	line-height: 16px;
	white-space: nowrap;
	word-break: normal;
}

.detail-card {
	padding: 0 23px;
}

.detail-row {
	min-height: 68px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.detail-row:last-child {
	border-bottom: 0;
}

.detail-label {
	flex: 0 0 auto;
	margin-right: 18px;
	color: #aeb3bb;
	font-size: 14px;
	line-height: 20px;
	white-space: nowrap;
	word-break: normal;
}

.detail-value {
	min-width: 0;
	overflow: hidden;
	color: #eef3f8;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-align: right;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.amount-value {
	color: #ffc29f;
}

.status-value {
	font-weight: 700;
}

.is-profit {
	color: #ff4a4a;
}

.is-loss {
	color: #aeb3bb;
}

.is-pending {
	color: #ffd0ad;
}

.status-pill.is-profit {
	background: rgba(96, 32, 32, 0.74);
}

.status-pill.is-loss {
	background: rgba(73, 78, 87, 0.62);
}

.status-pill.is-pending {
	background: rgba(115, 89, 58, 0.62);
}

@media screen and (max-width: 374px) {
	.detail-content {
		padding-right: 12px;
		padding-left: 12px;
	}

	.mission-header,
	.detail-card {
		padding-right: 16px;
		padding-left: 16px;
	}

	.mission-avatar {
		width: 52px;
		height: 52px;
		flex-basis: 52px;
	}

	.mission-info {
		margin-left: 12px;
	}

	.status-pill,
	.detail-label,
	.detail-value,
	.mission-number {
		font-size: 12px;
	}

	.mission-title {
		font-size: 14px;
	}
}

/* Keep the detail view in the same teal account-card family as the order list. */
.order-detail-page { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); color: #123d42; }
.order-detail-top { border-bottom-color: #c7e0dd; background: rgba(255, 255, 255, .97); box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }
.order-detail-top .big_tit { color: #073f47; }
.wallet-trigger { color: #075963; background: #e8f5f3; }
.mission-card, .detail-card { border-color: #c9e1de; background: #fff; box-shadow: 0 10px 22px rgba(12, 75, 79, .09); }
.mission-header { background: #f4fbfa; }
.mission-avatar { background: #e8f5f3; }
.mission-title { color: #074b53; }
.mission-number, .detail-label { color: #60797c; }
.detail-row { border-bottom-color: #deebea; }
.detail-value { color: #173f44; }
.amount-value { color: #075963; }
.is-profit { color: #08646d; }
.is-loss { color: #60797c; }
.is-pending { color: #786431; }
.status-pill.is-profit { background: #e1f3f0; }
.status-pill.is-loss { background: #edf3f2; }
.status-pill.is-pending { background: #fff4d9; }
</style>
